import React from 'react';
import styled from '@emotion/styled';
import { Link } from './Link';
import { StyledButton } from '../Button/Button';
import { IArrowButtonProps } from '../Button/ArrowButton';
import { themed, ITheme } from '../../themer';
import { LinkText } from './LinkText';

interface IArrowLinkButtonProps extends IArrowButtonProps {
	href: string;
	rel?: string;
	target?: string;
	secondary?: boolean;
}

export const StyledLinkButton = styled(StyledButton)<{}, ITheme>`
	padding: 0;

	a {
		padding: ${themed(({ button }) => button.padding)};
		text-decoration: none;
	}
`;

export function LinkButton({
	secondary,
	children,
	href,
	target,
	rel,
	...rest
}: IArrowLinkButtonProps) {
	return (
		<StyledLinkButton secondary={secondary} {...rest}>
			<Link href={href} target={target} rel={rel} inverted={!secondary}>
				<LinkText>{children}</LinkText>
			</Link>
		</StyledLinkButton>
	);
}
